module.exports = __webpack_public_path__ + "static/media/Chapter5.c11a8a74.pdf";